import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useModulesContext } from 'services/providers/ModulesProvider';
import ExternalPageLoader from 'utils/ExternalPageLoader';
import { BarRadius, Container, GlobalStyle, Provider, Background } from './Pages.styles';
import { Layout } from '@vertem-core/vertice-ds';
import FilteredModules from 'shared/FilteredModules';
import { HTML5Backend } from 'react-dnd-html5-backend';

const DynamicPage = () => {
  const location = useLocation();
  const params = useParams();
  const modules = useModulesContext();
  const pageName = location.pathname.substring(1);

  const updatedPageName = Object.entries(params).reduce((acc, [key, value]) => {
    return acc.replace(`/${value}`, `/:${key}`);
  }, pageName);

  const pageModule = modules.find((module) => module.componentPage === updatedPageName);

  if (!pageModule) {
    return (
      <div>
        <h2>Página não encontrada</h2>
        <p>Não foi possível encontrar um módulo para: {updatedPageName}</p>
        <pre>{JSON.stringify(modules, null, 2)}</pre>
      </div>
    );
  }

  return (
    <>
      <GlobalStyle />
      <Provider backend={HTML5Backend}>
        <Layout>
          <FilteredModules componentName="header" />
          <BarRadius />
          <Background>
            <Container>
              <ExternalPageLoader
                moduleUrl={pageModule.moduleUrl}
                containerName={pageModule.containerName}
                componentPath={pageModule.componentPath}
              />
            </Container>
          </Background>
          <FilteredModules componentName="footer" />
        </Layout>
      </Provider>
    </>
  );
};

export default DynamicPage;
